import { createFileRoute } from "@tanstack/react-router";
import { PaginaProvinciaView } from "@/components/PaginaProvinciaView";
import { paginaProvincia } from "@/lib/province-pagine";
import { headProvincia } from "@/lib/province-head";

const dati = paginaProvincia["brescia"]!;
const URL_PAGINA = `https://artigianidelcotto.com/${dati.slug}`;

export const Route = createFileRoute("/trattamento-pavimenti-cotto-brescia")({
  component: () => <PaginaProvinciaView dati={dati} url={URL_PAGINA} />,
  head: () => headProvincia(dati),
});
